import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=569ab88a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=569ab88a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ab88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569ab88a')) {
      api.createRecord('569ab88a', component.options)
    } else {
      api.reload('569ab88a', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=569ab88a&scoped=true", function () {
      api.rerender('569ab88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/Home.vue"
export default component.exports